import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const MeetingService = {
    getAllMeeting: async () => {
        try {
            const response = await axios.get(ENDPOINT.Meeting);
            return response.data;
        } catch (error) {
            console.error("Error fetching Meeting:", error.message);
            throw error;
        }
    },

    getAllByProject: async (pro_id) => {
        try {
            const response = await axios.get(`${ENDPOINT.Meeting}/project/${pro_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Meeting:", error.message);
            throw error;
        }
    },

getDropdownValues: async (field, pro_id) => {
        try {
            const response = await axios.get(`${ENDPOINT.Meeting}/dropdown/${field}`, {
                params: pro_id ? { pro_id } : {},
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching dropdown values:", error.message);
            throw error;
        }
    },

    getLastMeeting: async () => {
        try {
            const response = await axios.get(`${ENDPOINT.Meeting}/last`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Meeting:", error.message);
            throw error;
        }
    },

    getMeetingById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINT.Meeting}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Meeting:", error.message);
            throw error;
        }
    },

    createMeeting: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.Meeting, data, {
                headers: { "Content-Type": "application/json" },
            });
            return response.data;
        } catch (error) {
            console.error("Error creating Meeting:", error.message);
            throw error;
        }
    },

    updateMeeting: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.Meeting}/${id}`, data, {
                headers: { "Content-Type": "application/json" },
            });
            return response.data;
        } catch (error) {
            console.error("Error updating Meeting:", error.message);
            throw error;
        }
    },

    deleteMeeting: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.Meeting}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting Meeting:", error.message);
            throw error;
        }
    },
};